import { useMsal } from '@azure/msal-react';
import { MotifFormField, MotifOption, MotifLabel, MotifButton, MotifSelect, MotifProgressLoader } from '@ey-xd/motif-react';
import EYLogo from '../../assets/media/images/ey-logo-xl.png';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './LandingPage.scss';
import { getTenantDetails } from '../../redux/actions/User/user';

const LandingPage: React.FC = () => {
  const [selectedTenant, setSelectedTenant] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [showSpinner, setShowSpinner] = useState(false);
  const tenants = useSelector((state: any) => state?.user?.tenants) || [];

  useEffect(() => {
    // Identity is derived from the JWT server-side; no user_email argument.
    const p: any = dispatch(getTenantDetails());
    if (p && typeof p.catch === 'function') {
      p.catch((err: any) => {
        const status = err?.response?.status;
        const code = err?.response?.data?.error || err?.response?.data?.detail;
        if (status === 401) {
          console.warn('[Auth] /user/tenants returned 401 authentication_required. Redirecting to login.');
          try { sessionStorage.removeItem('idToken'); } catch {}
          instance.logoutRedirect();
        } else if (status === 403 && code === 'identity_mismatch') {
          console.error('[Auth] /user/tenants returned 403 identity_mismatch. Local user context is out of sync with the JWT. Forcing re-login.');
          try { sessionStorage.removeItem('idToken'); } catch {}
          instance.logoutRedirect();
        }
      });
    }
  }, []);

  const handleSelect = (e: any) => setSelectedTenant(e);

  const handleContinue = () => {
    setShowSpinner(true);
    if (selectedTenant) {
      sessionStorage.setItem('tenant', JSON.stringify(selectedTenant));
      setTimeout(() => {
        setShowSpinner(false);
        navigate('/reportGenerator');
      }, 1000);
    }
  };

  const handleSignOut = () => instance.logoutRedirect();

  return (
    <div className="landing-page">
      <MotifProgressLoader show={showSpinner} style={{ zIndex: 1 }} />
      <div className="landing-page__header">
        <img src={EYLogo} alt='EY Logo - Home' width={100} className="landing-page__logo" />
        <h1 className="landing-page__title">
          ASC AI Reporting Tool
        </h1>
      </div>
      <br />
      <div className="landing-page__content">
        <h2>Please select Engagement</h2>
        <p>
          To proceed, choose your engagement from the dropdown list. <br /> After making your selection, you’ll be logged in and ready to continue.
        </p>
        <span>Engagement (required)</span>
        <MotifFormField>
          {Object.keys(selectedTenant).length === 0 && <MotifLabel>Please Select Engagement</MotifLabel>}
          <MotifSelect onChange={handleSelect} value={selectedTenant}>
            {tenants.map((tenant:any) => (
              <MotifOption value={tenant} key={tenant.TenantId}>
                {tenant.TenantName}
              </MotifOption>
            ))}
          </MotifSelect>
        </MotifFormField>
        <div className="landing-page__actions">
          <MotifButton
            size="medium"
            variant="primary"
            onClick={handleContinue}
            disabled={ Object.keys(selectedTenant).length === 0 }
          >
            Continue
          </MotifButton>
          <MotifButton
            size="medium"
            variant="secondary"
            onClick={handleSignOut}
          >
            Quit
          </MotifButton>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;